import { PublicKey } from "@solana/web3.js";
import { getAccess } from "../../utils/Instructions";
export class Id extends PublicKey {
    getAccess(type) {
        return getAccess(this, type);
    }
}
//# sourceMappingURL=Id.js.map